import React, {useState, useRef, useEffect, useCallback, useMemo} from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { BaseUrl } from "../common/config";
import { http } from "../helper";
import DataTable from "react-data-table-component";
import Sidebar from "../common/sidebar";
import moment from "moment";
import CommonAlert from "../common/Commonalert";
import Popup from "../common/popup";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { dateformatwithuktime } from "../utilityfunctions";
import { useTranslation } from "react-i18next";

const FreeOrders = () => {
  const { t } = useTranslation();

  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_foodsolutions")
  ) {
    window.location.href = "/unauthorized";
  }

  const CUSTOM_STYLES = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px",
      },
    },
    cells: {
      style: {
        padding: "8px",
      },
    },
  };

  const PAGINATION_COMPONENT_OPTIONS = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  const RANGE_OPTIONS = [
    { value: "1", label: t("past_30_days_txt") },
    { value: "3", label: t("past_90_days_txt") },
    { value: "6", label: t("past_180_days_txt") },
    { value: "1Year", label: t("past_1_year_txt") },
    { value: "custom", label: t("custom_txt") },
  ];

  const str_replace = (product_name) => {
    if (product_name !== "") {
      return product_name
        .replaceAll("amp;", "&")
        .replaceAll("apos;'", "'' ")
        .replaceAll("quot;'", "'' ");
    }
    return product_name;
  };

  const formatDate = (dateString) => {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  };

  const [orders, setOrders] = useState([]);
  const [temporders, setTemporders] = useState([]);
  const [searchTextVal, setSearchTextVal] = useState("");
  const [loading, setLoading] = useState(true);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertPopup, setAlertPopup] = useState(false);
  const [isElementVisible, setIsElementVisible] = useState(false);
  const [datelabel, setDatelabel] = useState(t("past_30_days_txt"));
  const [datefilterlabel, setDatefilterlabel] = useState(t("past_30_days_txt"));
  const [dateRange, setDateRange] = useState("");
  const [datepickershow, setDatepickershow] = useState(false);
  const [datefrom, setDatefrom] = useState("");
  const [dateto, setDateto] = useState("");
  const [datefromLabel, setDatefromLabel] = useState("");
  const [datetoLabel, setDatetoLabel] = useState("");
  const [dateinvalid_error, setDateinvalidError] = useState(false);
  const [datefill_error, setDatefillError] = useState(false);
  const [searchstate, setSearchstate] = useState(false);
  const [searchFieldtxt, setSearchFieldtxt] = useState(t("order_number_txt"));
  const [notesPopup, setNotesPopup] = useState(false);
  const [note, setNote] = useState("");
  const [currentOrder, setCurrentOrder] = useState([]);
  const [orderlogs, setOrderlogs] = useState([]);
  const [noteError, setNoteError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadMessage, setUploadMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [showstatusDialog, setShowstatusDialog] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [orderStErr, setOrderStErr] = useState("");
  const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);
  const [statusLog, setStatusLog] = useState(null);
  const searchInputRef = useRef(null);
  const dropdownRef = useRef(null);

  const getAllOrders = useCallback(() => {
    let dateval = "";
    let dateval2 = "";
    if (datefrom && dateto) {
      dateval = format(new Date(datefrom), "yyyy-MM-dd");
      dateval2 = format(new Date(dateto), "yyyy-MM-dd");
    }
    const payload = {
      orderdays:
        dateRange && typeof (dateRange === "number")
          ? dateRange
          : dateRange && typeof (dateRange === "string")
            ? ""
            : 30,
      datefrom: dateval || "",
      dateto: dateval2 || "",
      from: "backend",
    };
    const URL = BaseUrl + "admin/freeorders";
    http
      .post(URL, payload)
      .then((response) => {
        const responseData = response.data.data;
        setOrders(responseData);
        setTemporders(responseData);
        setLoading(false);
        setAlertPopup(false);
        setAlertMessage("");
        setSearchstate(false);
        setSearchFieldtxt(t("order_number_txt"));
        setSearchTextVal("");
        document.querySelectorAll(".fa-refresh").forEach((row) => {
          row.classList.remove("fa-spin");
        });
      })
      .catch(() => {
        document.querySelectorAll(".fa-refresh").forEach((row) => {
          row.classList.remove("fa-spin");
        });
        setAlertPopup(true);
        setLoading(false);
        setAlertMessage(t("server_busy_txt"));
      });
  }, []);

  const handleClickOutside = useCallback((event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsElementVisible(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    getAllOrders();
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const openFilter = useCallback(() => {
    setIsElementVisible((prev) => !prev);
  }, []);

  const getOrderaccountdetails = useCallback((orderrow) => {
    const URL = BaseUrl + "admin/getfreeorderdetails/" + orderrow.OrderNumber;
    http
      .get(URL)
      .then((response) => {
        const responseData = response.data.data[0];
        setLoading(false);
        setAlertPopup(false);
        setAlertMessage("");
        setSelectedOrderDetails(responseData);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const closePopup = useCallback(() => {
    setShowPopup(false);
    setUploadMessage("");
  }, []);

  const statusSubmit = useCallback(() => {
    if (!selectedStatus) {
      setOrderStErr(t("select_order_status_txt"));
      return;
    }
    let loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    const URL =
      BaseUrl + "admin/freeordersStatusChange/" + currentOrder.OrderNumber;
    const payload = {
      OrderStatus: selectedStatus,
      createdBy: loginDetails.adminName,
    };
    http
      .put(URL, payload)
      .then(() => {
        setShowstatusDialog(false);
        setOrders((prev) =>
          prev.map((order) =>
            order.OrderNumber === currentOrder.OrderNumber
              ? { ...order, OrderStatus: selectedStatus }
              : order,
          ),
        );
        setTemporders((prev) =>
          prev.map((order) =>
            order.OrderNumber === currentOrder.OrderNumber
              ? { ...order, OrderStatus: selectedStatus }
              : order,
          ),
        );
        setSelectedStatus("");
      })
      .catch((err) => {
        console.log("Error:", err);
      });
  }, [selectedStatus, currentOrder]);

  const ChangeOrderstatus = useCallback((order) => {
    setShowstatusDialog(true);
    setCurrentOrder(order);
  }, []);

  const handleReset = useCallback(() => {
    setOrders(temporders);
    setSearchstate(false);
    setSearchFieldtxt(t("order_number_txt"));
    setSearchTextVal("");
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
  }, [temporders]);

  const handleChange = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchTextVal(value);
      const lowercasedValue = value.toLowerCase().trim();
      const searchData = temporders.filter((item) => {
        if (Number.isInteger(Number(lowercasedValue))) {
          return item.OrderNumber.toLowerCase().includes(lowercasedValue);
        }
        return false;
      });
      setOrders(searchData);
      setSearchstate(true);
    },
    [temporders],
  );

  const handleNoteChange = useCallback((value) => {
    setNote(value.trim());
    setNoteError(false);
  }, []);

  const filterData = useCallback(() => {
    const value = searchTextVal;
    const lowercasedValue = value.toLowerCase().trim();
    const searchData = temporders.filter((item) => {
      if (Number.isInteger(Number(lowercasedValue))) {
        return item.OrderNumber.toLowerCase().includes(lowercasedValue);
      } else if (
        lowercasedValue !== "a" &&
        lowercasedValue !== "k" &&
        searchFieldtxt === t("account_code_txt")
      ) {
        return item.accountCode.toLowerCase().includes(lowercasedValue);
      } else if (lowercasedValue !== "a" && lowercasedValue !== "k") {
        return item.OrderStatus.toLowerCase().includes(lowercasedValue);
      } else if (lowercasedValue === "a" || lowercasedValue === "k") {
        return item.PaymentMethod.toLowerCase().includes(lowercasedValue);
      }
      return false;
    });
    setOrders(searchData);
    setAlertPopup(false);
    setSearchstate(true);
  }, [searchTextVal, temporders, searchFieldtxt]);

  const applyOrderFilters = useCallback(() => {
    let dateinvalid = false;
    if (dateRange !== "") {
      setIsElementVisible(false);
      setLoading(true);
      setAlertPopup(false);
      setDateinvalidError(false);
      setDatefillError(false);
      let payload = {
        orderdays: dateRange,
        datefrom: "",
        dateto: "",
      };
      if (dateRange === "custom") {
        if (datefrom && dateto) {
          const dateval = format(new Date(datefrom), "yyyy-MM-dd");
          const dateval2 = format(new Date(dateto), "yyyy-MM-dd");
          setDatefromLabel(datefrom);
          setDatetoLabel(dateto);
          setDatefillError(false);
          payload = { orderdays: "", datefrom: dateval, dateto: dateval2 };
        } else {
          dateinvalid = true;
          setDatefillError(true);
          setIsElementVisible(true);
          setLoading(false);
        }
      } else {
        setDatelabel(datefilterlabel);
        payload = { orderdays: dateRange, datefrom: "", dateto: "" };
        setDatefromLabel("");
        setDatetoLabel("");
      }
      if (!dateinvalid) {
        const URL = BaseUrl + "admin/freeorders";
        http
          .post(URL, payload)
          .then((response) => {
            const responseData = response.data.data;
            setOrders(responseData);
            setTemporders(responseData);
            setLoading(false);
            if (searchstate) {
              const value = searchTextVal;
              const lowercasedValue = value.toLowerCase().trim();
              const searchData = responseData.filter((item) => {
                if (Number.isInteger(Number(lowercasedValue))) {
                  return item.OrderNumber.toLowerCase().includes(
                    lowercasedValue,
                  );
                } else if (
                  lowercasedValue !== "a" &&
                  lowercasedValue !== "k" &&
                  searchFieldtxt === t("account_code_txt")
                ) {
                  return item.accountCode
                    .toLowerCase()
                    .includes(lowercasedValue);
                } else if (lowercasedValue !== "a" && lowercasedValue !== "k") {
                  return item.OrderStatus.toLowerCase().includes(
                    lowercasedValue,
                  );
                } else if (lowercasedValue === "a" || lowercasedValue === "k") {
                  return item.PaymentMethod.toLowerCase().includes(
                    lowercasedValue,
                  );
                }
                return false;
              });
              setOrders(searchData);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
            setLoading(false);
          });
      }
    }
  }, [
    dateRange,
    datefrom,
    dateto,
    datefilterlabel,
    searchstate,
    searchTextVal,
    searchFieldtxt,
  ]);

  const clearFilterOrderSearch = useCallback(() => {
    setIsElementVisible(false);
    setDateRange("3");
  }, []);

  const handleFilterChange = useCallback((e) => {
    if (e.value !== "") {
      let valueDates = "";
      if (e.value === "1") {
        valueDates = 30;
        setDatepickershow(false);
        setDatefilterlabel(t("past_30_days_txt"));
      } else if (e.value === "3") {
        valueDates = 30 * 3;
        setDatepickershow(false);
        setDatefilterlabel(t("past_90_days_txt"));
      } else if (e.value === "6") {
        valueDates = 30 * 6;
        setDatepickershow(false);
        setDatefilterlabel(t("past_180_days_txt"));
      } else if (e.value === "1Year") {
        valueDates = 365;
        setDatepickershow(false);
        setDatefilterlabel(t("past_1_year_txt"));
      } else if (e.value === "custom") {
        valueDates = "custom";
        setDatepickershow(true);
        setDatefilterlabel("");
      }
      setDateRange(valueDates);
      setDateinvalidError(false);
    }
  }, []);

  const DateChange = useCallback(
    (value, type) => {
      if (type === "from") {
        setDatefrom(value);
        setDateinvalidError(false);
      } else if (type === "to") {
        const dateval = format(new Date(datefrom), "yyyy-MM-dd");
        const dateval2 = format(new Date(value), "yyyy-MM-dd");
        if (dateval > dateval2) {
          setDateto("");
          setDateinvalidError(true);
        } else {
          setDateto(value);
          setDateinvalidError(false);
        }
      }
    },
    [datefrom],
  );

  const orderNotelog = useCallback((order) => {
    setIsLoading(true);
    setNotesPopup(true);
    setCurrentOrder(order);
    const URL = BaseUrl + "admin/orderlog/" + order.OrderNumber;
    http
      .get(URL)
      .then((response) => {
        setIsLoading(false);
        setOrderlogs(response.data.data);
        setNotesPopup(true);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error getting status:", error);
      });
  }, []);

  const hideNotePopup = useCallback(() => {
    setNotesPopup(false);
    setNoteError(false);
    setOrderlogs("");
    setNote("");
  }, []);

  const orderStatuslog = useCallback((order) => {
    setIsLoading(true);
    const URL = BaseUrl + "admin/freeorderStatuslog/" + order.OrderNumber;
    http
      .get(URL)
      .then((response) => {
        setIsLoading(false);
        setStatusLog({ order, logs: response.data.data });
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error getting status:", error);
      });
  }, []);

  const updateNoteLog = useCallback(() => {
    if (note.trim() !== "") {
      let loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      const noteURL = BaseUrl + "admin/orderlog";
      const notepayload = {
        orderID: currentOrder.OrderNumber,
        noteText: note,
        createdBy: loginDetails.adminName,
      };
      setIsLoading(true);
      http
        .post(noteURL, notepayload)
        .then(() => {
          setNotesPopup(false);
          setIsLoading(false);
          setShowPopup(true);
          setUploadMessage(t("order_note_submit_success_txt"));
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("Error submitting note:", error);
        });
    } else {
      setNoteError(true);
    }
  }, [note, currentOrder]);

  const renderOrderDetailsPopup = (order) => (
    <Popup
      extClass="order-pop free-sample-details-pop"
      headMoreTxt={
        <>
          <div className="order-top">
            <div className="bottom order-flex">
              <div className="order_no_details">
                <h3>{t("order_no_txt")} - {order.OrderNumber}</h3>
                <p>
                  {t("order_placed_on_txt")}:{" "}
                  <span className="date">
                    {" "}
                    {moment(order.createdAt).format("DD/MM/YYYY hh:mm A")}
                  </span>{" "}
                </p>
                <p>
                  {t("status_txt")}:<span className="pay"> {order.OrderStatus}</span>
                </p>
                <p>
                  {t("code_used_txt")}:<span className="pay"> {order.Code}</span>
                </p>
              </div>
              <div className="order_account_details">
                <p>
                  <span className="highlight">{t("company_name_txt")}: </span>{" "}
                  <span className="date ord-act-data">
                    {" "}
                    {order.companyName}
                  </span>{" "}
                </p>
                <p>
                  <span className="highlight">{t("contact_person_txt")}: </span>{" "}
                  <span className="date ord-act-data">
                    {" "}
                    {order.userName}
                  </span>{" "}
                </p>
                <p>
                  <span className="highlight">{t("email_address_txt")}: </span>{" "}
                  <span className="pay ord-act-data"> {order.userEmail}</span>
                </p>
                <p>
                  <span className="highlight">{t("contact_number_txt")}: </span>{" "}
                  <span className="date ord-act-data">
                    {" "}
                    {order.userContactNo}
                  </span>{" "}
                </p>
                <p>
                  <span className="highlight">{t("address_txt")}: </span>{" "}
                  <span className="pay ord-act-data"> {order.userAddress}</span>
                </p>
              </div>
            </div>
          </div>
        </>
      }
      closebtn={
        <>
          <div className="pop-header-top order-top">
            <div className="head">
              <h4>{t("free_sample_order_details_txt")} - {order.OrderNumber}</h4>
            </div>
            <span
              onClick={() => setSelectedOrderDetails(null)}
              className="close"
            ></span>
          </div>
        </>
      }
      bodyMoreTxt={
        <>
          <div className="modal-table">
            <h4 className="item-title">{t("ordered_items_txt")}</h4>
            <div className="checkout-table">
              <div className="table_overflow">
                <table>
                  <thead>
                    <tr>
                      <td>{t("product_txt")}</td>
                      <td>{t("unit_of_sale_txt")}</td>
                    </tr>
                  </thead>
                  <tbody>
                    {order.items.map((item, index) => (
                      <tr key={index}>
                        <td data-title="Product" className="data-product-hide">
                          {str_replace(item.Description)} (
                          {item.ProductNumber.includes("_")
                            ? item.ProductNumber.substring(
                                0,
                                item.ProductNumber.indexOf("_"),
                              )
                            : item.ProductNumber}
                          )
                        </td>
                        <td data-title={t("unit_of_sale_txt")}>{item.PricingUnit}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="ord-free-disclaimer">
            <p>
              <i className="fa fa-exclamation-circle"></i>{t("free_sample_product_popup_txt")}
            </p>
          </div>
        </>
      }
    />
  );

  const renderStatusLogPopup = (order, order_det) => (
    <Popup
      extClass="info-poup show"
      closebtn={
        <>
          <span onClick={() => setStatusLog(null)} className="close"></span>
        </>
      }
      headMoreTxt={
        <>
          <div className="order-top">
            <h4>
              <span>{t("order_status_log_txt")} - {order.OrderNumber}</span>
            </h4>
          </div>
        </>
      }
      bodyMoreTxt={
        <>
          <div className="bottom vendor-details prd-log">
            {order_det && order_det.length > 0 ? (
              order_det.map((prd_item, idx) => {
                const createdby = prd_item.createdBy ? (
                  <>
                    <span className="log-user">{prd_item.createdBy}</span>
                    <span className="log-line">|</span>
                  </>
                ) : (
                  ""
                );
                return (
                  <div className="info-item" key={idx}>
                    <div className="info-innr">
                      <div className="flex-log-hdr">
                        <p>
                          <span className="labeltxt acn-by">
                            {prd_item.Status}
                          </span>
                        </p>
                        <div className="hdrlog-rit">
                          {createdby}
                          <span className="log-date">
                            {dateformatwithuktime(prd_item.createdAt)}
                          </span>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="no-logs">{t("no_logs_txt")}</div>
            )}
          </div>
        </>
      }
    />
  );

  const columns = useMemo(
    () => [
      {
        name: t("order#_number_txt"),
        selector: (row) => row.OrderNumber,
        sortable: true,
      },
      {
        name: t("name_txt"),
        selector: (row) => row.userName,
        sortable: false,
      },
      {
        name: t("email_address_txt"),
        selector: (row) => row.userEmail,
        sortable: false,
      },
      {
        name: t("ordered_date_txt"),
        selector: (row) => moment(row.createdAt).format("DD/MM/YYYY"),
        sortable: false,
      },
      {
        name: t("status_txt"),
        selector: (row) => row.OrderStatus,
        sortable: true,
      },
      {
        name: t("actions_txt"),
        selector: (row) => (
          <div className="order-action-tbl">
            <a
              className="title-tooltip title-up button"
              data-title={t("view_details_txt")}
              style={{ color: "white" }}
              onClick={() => getOrderaccountdetails(row)}
            >
              <i className="fa fa-eye" aria-hidden="true"></i>
            </a>
            <a
              className="title-tooltip title-up button"
              data-title={t("change_status_txt")}
              style={{ color: "white" }}
              onClick={() => ChangeOrderstatus(row)}
            >
              <i className="fa fa-refresh" aria-hidden="true"></i>
            </a>
            <a
              className="button title-tooltip title-up"
              data-title={t("order_note_log_txt")}
              onClick={() => orderNotelog(row)}
            >
              <i className="fa fa-history"></i>
            </a>
            <a
              className="button title-tooltip title-up"
              data-title={t("status_log_txt")}
              onClick={() => orderStatuslog(row)}
            >
              <i className="fa fa-random"></i>
            </a>
          </div>
        ),
        sortable: false,
      },
    ],
    [getOrderaccountdetails, ChangeOrderstatus, orderNotelog, orderStatuslog],
  );

  let currentRangeLabel = "";
  let currentRangeValue = "";
  if (dateRange === "1") {
    currentRangeLabel = t("past_30_days_txt");
    currentRangeValue = "1";
  } else if (dateRange === "3") {
    currentRangeLabel = t("past_90_days_txt");
    currentRangeValue = "3";
  } else if (dateRange === "6") {
    currentRangeLabel = t("past_180_days_txt");
    currentRangeValue = "6";
  } else if (dateRange === "365") {
    currentRangeLabel = t("past_1_year_txt");
    currentRangeValue = "1Year";
  } else if (dateRange === "custom") {
    currentRangeLabel = t("custom_txt");
    currentRangeValue = "custom";
  } else if (dateRange === "") {
    currentRangeLabel = t("past_30_days_txt");
    currentRangeValue = "1";
  }

  const nodatacomponent =
    searchstate === false ? (
      datefromLabel && datetoLabel ? (
        <div className="no-records-found">
          {t("no_records_date_range")
            .replace("{from}", formatDate(datefromLabel))
            .replace("{to}", formatDate(datetoLabel))}
        </div>
      ) : (
        <div className="no-records-found">
          {t("no_records_for_date").replace("{date}", datelabel)}
        </div>
      )
    ) : (
      <div className="no-records-found">
        {t("no_records_search")}
      </div>
    );

  return (
    <>
      {alertPopup === true && (
        <CommonAlert title={t("alert_txt")} message={alertMessage} />
      )}
      <section className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <div className="cart-block">
            <div className="container">
              <h1 className="checkout-title">{t("free_sample_order_txt")}</h1>
              <div className="right-table-outer-wrap">
                <div className="table-filter search-orders orders-search-bx">
                  <div className="orders-drop-left">
                    <div className="table-search-reset">
                      <div className="table-search">
                        <input
                          type="text"
                          ref={searchInputRef}
                          onChange={handleChange}
                          placeholder={`${t("searchby_txt")} ${searchFieldtxt}`}
                        />
                      </div>
                      <button
                        className="submitbtn button search-ord-btn"
                        onClick={filterData}
                      >
                        <i className="fa fa-search"></i>
                      </button>
                      <button
                        className="resetbtn"
                        type="reset"
                        onClick={handleReset}
                      >
                        {t("reset_txt")}
                      </button>
                    </div>
                  </div>
                  <div className="select-drop" ref={dropdownRef}>
                    <a
                      className={
                        isElementVisible === true
                          ? "filter-btn button active"
                          : "filter-btn button"
                      }
                      onClick={openFilter}
                    >
                      {t("more_filter_txt")}{" "}
                      <span className="filter-icon">
                        <i className="fa fa-sliders" aria-hidden="true"></i>
                      </span>
                    </a>
                    <div
                      className={
                        isElementVisible === true
                          ? "filter-bx show"
                          : "filter-bx"
                      }
                    >
                      <div className="filter-date-range">
                        <div className="fltr-dt-wrap">
                          <label>{t("date_range_txt")}:</label>
                          <Select
                            defaultValue={{
                              value: currentRangeValue,
                              label: currentRangeLabel,
                            }}
                            options={RANGE_OPTIONS}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: 6,
                              height: 40,
                              colors: {
                                ...theme.colors,
                                primary25: "#e0dedb",
                                primary: "#ec2f45",
                              },
                            })}
                            onChange={handleFilterChange}
                          />
                        </div>
                      </div>
                      <div
                        className={
                          datepickershow === true
                            ? "fltr-dt-range show"
                            : "fltr-dt-range"
                        }
                      >
                        <div className="fltr--date">
                          <span>{t("from_txt")}</span>
                          <DatePicker
                            selected={datefrom}
                            placeholderText={t("select_date_txt")}
                            showDisabledMonthNavigation
                            dateFormat="dd/MM/yyyy"
                            disablePast={true}
                            maxDate={new Date()}
                            onChange={(date) => DateChange(date, "from")}
                          />
                          <span className="date-icon">
                            <i
                              className="fa fa-calendar"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </div>
                        <div className="fltr--date">
                          <span>{t("to_txt")}</span>
                          <DatePicker
                            selected={dateto}
                            placeholderText={t("select_date_txt")}
                            showDisabledMonthNavigation
                            dateFormat="dd/MM/yyyy"
                            disablePast={true}
                            maxDate={new Date()}
                            onChange={(date) => DateChange(date, "to")}
                          />
                          <span className="date-icon">
                            <i
                              className="fa fa-calendar"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </div>
                      </div>
                      {dateinvalid_error === true && (
                        <span className="color-red">
                          {t("invalid_start_end_date_txt")}
                        </span>
                      )}
                      {datefill_error === true && (
                        <span className="color-red">
                          {t("fill_from_to_date_txt")}
                        </span>
                      )}
                      <div className="filter-btns">
                        <button
                          type="button"
                          className="button clear-btn"
                          onClick={clearFilterOrderSearch}
                        >
                          {t("clear_txt")}
                        </button>
                        <button
                          type="button"
                          className="button apply-btn"
                          onClick={applyOrderFilters}
                        >
                          {t("apply_txt")}{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {orders.length > 0 && loading === false && (
                  <p className="admin-order account-total-records">
                    {t("total_record_txt")} {orders.length > 0 ? orders.length : ""}
                    {datefromLabel && datetoLabel ? (
                      <span>
                        {" "}
                        ({t("from_txt")} {formatDate(datefromLabel)} {t("to_txt")}{" "}
                        {formatDate(datetoLabel)})
                      </span>
                    ) : datelabel ? (
                      ` (${datelabel})`
                    ) : (
                      ""
                    )}
                  </p>
                )}
                <div className="checkout-table table_overflow free-sample-orders orders-table">
                  <DataTable
                    columns={columns}
                    noDataComponent={nodatacomponent}
                    data={orders}
                    customStyles={CUSTOM_STYLES}
                    pagination
                    paginationPerPage={25}
                    progressPending={loading}
                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                    paginationComponentOptions={PAGINATION_COMPONENT_OPTIONS}
                  />
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
        {selectedOrderDetails && renderOrderDetailsPopup(selectedOrderDetails)}
        {statusLog && renderStatusLogPopup(statusLog.order, statusLog.logs)}
      </section>
      {/* Loader & Popup START */}
      <div className="common">
        {/* <Alert extractId="success" customContent="Cart Added Success" /> */}
      </div>
      {/* Loader & Popup END */}
      {showstatusDialog && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("order_status_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <div className="form-field bottom vendor-details">
                  <div className="input-field col-1">
                    <span className="labeltxt">{t("status_txt")}</span>
                    <select
                      name="orderstatuschange"
                      onChange={(e) => {
                        setSelectedStatus(e.target.value);
                        setOrderStErr("");
                      }}
                      defaultValue={selectedStatus || ""}
                    >
                      <option value="" disabled>
                        {t("select_txt")}
                      </option>
                      <option value="Acknowledged">{t("acknowledged_txt")}</option>
                      <option value="Completed">{t("completed_txt")}</option>
                      <option value="Cancelled">{t("cancelled_txt")}</option>
                    </select>
                    {orderStErr && (
                      <div className="error-msg">{orderStErr}</div>
                    )}
                  </div>
                  <div className="btn-field btn-center">
                    <button type="button" onClick={statusSubmit}>
                      {t("submit_txt")}
                    </button>
                    &nbsp;&nbsp;
                    <button
                      onClick={() => {
                        setShowstatusDialog(false);
                        setSelectedStatus("");
                      }}
                    >
                      {t("cancel_txt")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {notesPopup && (
        <Popup
          extClass="info-poup show"
          closebtn={
            <>
              <span onClick={hideNotePopup} className="close"></span>
            </>
          }
          headMoreTxt={
            <>
              <div className="order-top">
                <h4>
                  <span>{t("notes_for_order_txt")} - {currentOrder.OrderNumber}</span>
                </h4>
              </div>
            </>
          }
          bodyMoreTxt={
            <>
              <div className="bottom vendor-details ordernotes-log">
                <div className="order-notes">
                  <div className="input-field">
                    <label htmlFor="note-label">{t("enter_your_note_txt")}</label>
                    <textarea
                      name="note"
                      onChange={(e) => handleNoteChange(e.target.value)}
                    ></textarea>
                    {noteError && (
                      <div className="err-msg">{t("update_note_txt")}</div>
                    )}
                  </div>
                </div>
                <div className="alert-buttons btn-field btn-center">
                  <button
                    onClick={updateNoteLog}
                    className="popup-alert-btn button"
                  >
                    {t("submit_txt")}
                  </button>
                  <button
                    onClick={hideNotePopup}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </button>
                </div>
                {isLoading ? (
                  <div className="loading-buffer"></div>
                ) : (
                <div className="order-notes-log">
                  {orderlogs &&
                    orderlogs.length > 0 &&
                    orderlogs.map((ord_item, idx) => (
                      <div className="info-item" key={idx}>
                        <div className="info-innr">
                          <p>
                            <span className="labeltxt">{t("date_txt")}: </span>
                            {dateformatwithuktime(ord_item.createdAt)}
                          </p>
                          <p>
                            <span className="labeltxt log-reason">{t("note_txt")} </span>
                            {ord_item.noteText}
                          </p>
                          <p>
                            <span className="labeltxt log-reason">
                              {t("created_by_txt")}:{" "}
                            </span>
                            {ord_item.createdBy}
                          </p>
                        </div>
                      </div>
                    ))}
                </div>
                )}
              </div>
            </>
          }
        />
      )}
      {showPopup && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{uploadMessage}</p>
                <div className="alert-buttons">
                  <button
                    onClick={closePopup}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FreeOrders;
